import WINDOW from "../../../utils/window";
import setDefaultParameters from "./set-default-parameters";

/**
 * @param {Map<String, any>} map
 * @returns {Map<String, any>}
 */
const getDefaultTimeoutParameters = (map) => {
  const defaults = new Map([
    ["start", [0, "ms"]],
    ["end", [0, "ms"]],
    ["lasts", [0, "ms"]],
  ]);

  return setDefaultParameters(defaults, map);
};

export default getDefaultTimeoutParameters;
